import mapValues from "lodash-es/mapValues";
/**
 * Returns a new object with a mapping function applied to each value of the input object.
 * This is a wrapper around Lodash _.mapValues with better typing.
 *
 * Ex:
 * ```
 * const input = { x: 2, y: 7 }
 * const result = mapRecord(input, value => value + 1)
 * // result { x: 3, y: 8 }
 * ```
 *
 * @param record Object to be mapped
 * @param mapFn Function to apply to each value in `record` that yields a value for the resulting object
 * @returns Object of the same shape as the input `record` with the mapping function applied to each value
 */
export const mapRecord = <Key extends string | number | symbol, Value, Output>(
  record: Record<Key, Value>,
  mapFn: (value: Value, key: string, object: typeof record) => Output
) => mapValues<typeof record, Output>(record, mapFn);
